export default "__VITE_ASSET__B6cecxjU__"